import {useFormContext} from '@yandex-delivery/form'

import type {Order} from 'src/shared/types'

export function useSourcePointDropOffPointId() {
  const {watch} = useFormContext<Order>()

  return watch('sourcePoint.dropOffPoint.point.id')
}
